import Assets from './assets';
export default Assets;
